import styled from 'styled-components';

export const Body = styled.div`
  margin: 24px 51px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  font-size: 16px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 24px;
`;
